import { StyledFlex } from '@dreryk/react-components';

import { ElevenLabsTranscriptionConfig } from '../transcription/ElevenLabsTranscriptionConfig';
import { FieldProposalReviewModal } from '../components/FieldProposalReviewModal';
import { ProcessingIndicator } from '../components/ProcessingIndicator';
import { RecordButton } from '../components/RecordButton';
import { RecordingConsentGate } from '../components/RecordingConsentGate';
import { RecordingTimer } from '../components/RecordingTimer';
import { SilenceCountdown } from '../components/SilenceCountdown';
import { SummaryButton } from '../components/SummaryButton';
import { VoiceVisualizer } from '../components/VoiceVisualizer';
import type { Field } from '../types';

import { useContinuousPanel } from './ContinuousPanel.hooks';

type ContinuousPanelProps = {
   isQuotaExhausted: boolean;
   config: ElevenLabsTranscriptionConfig;
   onRecordingChange: (isRecording: boolean) => void;
   onAppendToField?: (field: Field, text: string) => void;
};

const KEY_PREVIEW_LENGTH = 30;

export const ContinuousPanel = (props: ContinuousPanelProps): JSX.Element => {
   const panel = useContinuousPanel(props.config, props.onRecordingChange);

   return (
      <>
         <RecordingConsentGate
            open={panel.consentOpen}
            onConfirm={panel.handleConsentConfirm}
            onCancel={panel.handleConsentCancel}
         />

         <StyledFlex direction={'column'} gap={12}>
            <VoiceVisualizer mediaStream={panel.transcription.mediaStream} isActive={panel.isRecording} />
            <SilenceCountdown secondsRemaining={panel.silenceSecondsRemaining} />
            {panel.totalRecordingSeconds > 0 || panel.isRecording ? (
               <RecordingTimer totalSeconds={panel.totalRecordingSeconds} />
            ) : null}
            <RecordButton
               recording={panel.isRecording}
               disabled={panel.isConnecting || props.isQuotaExhausted}
               onClick={panel.handleRecordClick}
            />
            {/* {panel.utterances.length > 0 || panel.isRecording ? (*/}
            {/*   <StyledFlex gap={8} direction={'column'}>*/}
            {/*      <Notification*/}
            {/*         testId={'conversationNotification'}*/}
            {/*         type={NotificationType.INFO}*/}
            {/*         size={NotificationSize.SMALLEST}*/}
            {/*         label={translationKeys.continuousMode.chatInfo}*/}
            {/*      />*/}
            {/*      <ConversationChat utterances={panel.utterances} isRecording={panel.isRecording} />*/}
            {/*   </StyledFlex>*/}
            {/* ) : null}*/}

            {panel.hasContinuousText && !panel.isRecording && !panel.summaryLoading ? (
               <SummaryButton
                  isLoading={false}
                  disabled={!panel.hasContinuousText || panel.isRecording}
                  onSummarize={panel.handleSummarize}
               />
            ) : null}

            {panel.summaryLoading ? <ProcessingIndicator fieldsLocked={false} /> : null}
         </StyledFlex>

         {panel.showProposalModal && panel.summaryResult ? (
            <FieldProposalReviewModal
               key={`${panel.summaryResult.interview.slice(
                  0,
                  KEY_PREVIEW_LENGTH
               )}|${panel.summaryResult.examination.slice(
                  0,
                  KEY_PREVIEW_LENGTH
               )}|${panel.summaryResult.recommendations.slice(0, KEY_PREVIEW_LENGTH)}`}
               interview={panel.summaryResult.interview}
               examination={panel.summaryResult.examination}
               recommendations={panel.summaryResult.recommendations}
               unassigned={panel.summaryResult.unassigned}
               onClose={panel.handleCloseProposalModal}
               onAppendToField={props.onAppendToField}
            />
         ) : null}
      </>
   );
};
